import {PageContent} from '@/components/organisms'
import {getPublicImageUrl} from '@/utils/commons'
import './_mediaGallery.scss'

const MediaGallery = ({productData}) => {
  const getMediaItems = () => {
    return (productData || [])
      .filter(item => Boolean(item?.mediaUrl))
      .slice()
      .sort((a, b) => Number(a?.displayOrder || 0) - Number(b?.displayOrder || 0))
  }
  const mediaItems = getMediaItems()

  return (
    <>
      <PageContent className="media-gallery-component bg-neutral-800 text-white" pageContentWrapperClassName="relative">
        <div className="grid grid-cols-3 gap-6">
          {mediaItems.length === 0 ? (
            <div className="flex flex-col gap-8">
              <div className="file-media flex h-[300px] items-center justify-center overflow-hidden rounded-lg border border-gray-600 p-3">
                <img
                  src={getPublicImageUrl('img/no-product-image-found.png')}
                  alt="no image"
                  className="h-full w-full rounded-lg object-contain"
                />
              </div>
              {/* <div className="mt-2 w-full">
                <div className="media-title-row flex items-center border-b border-neutral-600">
                  <span className="media-title-label">Title</span>
                  <span className="media-title-filename">No filename</span>
                </div>
              </div> */}
            </div>
          ) : (
            mediaItems.map(item => (
              <div key={item.displayOrder} className="flex flex-col gap-8">
                <div className="file-media flex h-[300px] items-center justify-center overflow-hidden rounded-lg border border-gray-600 p-3">
                  <img
                    src={item.mediaUrl}
                    alt={item?.mediaTitle || 'Media'}
                    className="h-full w-full rounded-lg object-contain"
                  />
                </div>
                {/* TODO add title back but for now it's removed */}
                {/* <div className="mt-2 w-full">
                  <div className="media-title-row flex items-center border-b border-neutral-600">
                    <span className="media-title-label">Title</span>
                    <span className="media-title-filename">{item.mediaUrl.split('/').pop()}</span>
                  </div>
                </div> */}
              </div>
            ))
          )}
        </div>
      </PageContent>
    </>
  )
}

export default MediaGallery
